import authenticationService from '../../services/authentication/AuthenticationService';
import documentService from '../../services/document/DocumentService';
import {openOrSaveFile} from '../../utils/http';

export function handleDownloadDossierOverview(organisationId, currentLocale, dossierCountry) {
  authenticationService.authRedirect(
    documentService.downloadDossierOverview(organisationId, currentLocale, dossierCountry)
  )
    .then(authUrl => openOrSaveFile(authUrl));
}

export function handleFocusDocument(focusedDocument) {
  const documentToFocus = document.getElementById(`document-details-${focusedDocument.correlationId}`);
  if (!documentToFocus.classList.contains('open')) {
    documentToFocus.firstChild.click();
  }

  documentToFocus.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
}
